import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { filterRequest } from "../../utilities/apiManager";
import axiosInstance from "../../utilities/axiosInstance";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getAdvance = createAsyncThunk(
  "advance/getAdvance",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axiosInstance.get(
        `/advance?page=${page}&size=${size}&query=${query}${filter}`
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createAdvance = createAsyncThunk(
  "advance/createAdvance",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(
        `/advance`,
        args
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateAdvance = createAsyncThunk(
  "advance/updateAdvance",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/advance/${args._id}`,
        args
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteAdvance = createAsyncThunk(
  "advance/deleteAdvance",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.delete(
        `/advance/${args._id}`
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const advanceSlice = createSlice({
  name: "advance",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAdvance.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getAdvance.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data;
        state.itemsCount = payload.itemsCount;
        state.pages = payload.pages;
      })
      .addCase(getAdvance.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createAdvance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createAdvance.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data.push(payload.data);
        state.itemsCount++;
        state.error = null;
      })
      .addCase(createAdvance.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateAdvance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateAdvance.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        const indexAt = state.data.findIndex(el => el._id === payload.data._id);
        state.data[indexAt] = payload.data;
        state.error = null;
      })
      .addCase(updateAdvance.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deleteAdvance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteAdvance.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = state.data.filter(el => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteAdvance.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default advanceSlice.reducer;